import { render, staticRenderFns } from "./boolean-value-view.vue?vue&type=template&id=20a2b436&"
import script from "./boolean-value-view.vue?vue&type=script&lang=ts&"
export * from "./boolean-value-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports